import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { environment } from '../../src/environments/environment';
import { appConfig } from './app.config';

@Injectable({
  providedIn: 'root'
})
export class HttpCancelService {
  private pendingHTTPRequests$ = new Subject<void>();
  public isMultiReceiptRequest: boolean = false;
  public whiteListUrls: string[] = [
    environment.basePath + 'dashboard/v2/iss45/multi_receipt',
    environment.basePath + 'dashboard/v1/company/department/sales',
    environment.basePath + 'dashboard/v1/department_item_sales',
    environment.basePath + 'dashboard/v1/location_sales',
    environment.basePath + 'dashboard/v1/daily_tender_sales',
    environment.basePath + 'dashboard/v1/transaction',
    environment.basePath + 'trueretailadmin/v2/regionhierarchy',
    environment.basePath + 'trueretailadmin/v2/selected-table-columns',
    environment.basePath + 'trueretailadmin/v2/user-profile',
    environment.basePath + 'trueretailadmin/v2/users/company'
  ]
  public logoUrls = [
    environment.basePath + 'trueretailadmin/v2/file/company-logo',
    appConfig.uploadCompanyLogo,
    environment.basePath + 'trueretailadmin/v2/file/user-profile',
  ]
  constructor() { }

  public cancelPendingRequests() {
    this.pendingHTTPRequests$.next();
  }

  public onCancelPendingRequests() {
    return this.pendingHTTPRequests$.asObservable();
  }
}
